import React from 'react';
import { useParams } from 'react-router-dom';
import '../App.css';
import policies, { DEFAULT_POLICY } from '../data/privacyPolicies';

const Section = ({ number, title, content }) => {
  if (!content) return null;
  return (
    <section className="pp-section">
      <h2 className="pp-h2">{number}. {title}</h2>
      <div className="pp-text">{content}</div>
    </section>
  );
};

const PrivacyPolicy = () => {
  const { appName } = useParams();
  const data = policies[appName?.toLowerCase()];

  if (!data) {
    return (
      <div className="privacy-page">
        <div className="privacy-card">
          <h1 className="pp-h1">Privacy Policy Not Found</h1>
          <p className="pp-text">No privacy policy exists for "{appName}".</p>
        </div>
      </div>
    );
  }

  const name = data.name || appName;
  const lastUpdated = data.lastUpdated || DEFAULT_POLICY.lastUpdated;
  const email = data.contactEmail || DEFAULT_POLICY.contactEmail;

  return (
    <div className="privacy-page">
      <div className="privacy-card">
        <h1 className="pp-h1">{name} Privacy Policy</h1>
        <p className="pp-updated">Last updated: {lastUpdated}</p>

        <p className="pp-text pp-intro">{data.intro}</p>

        <Section number="1" title="Information We Collect" content={data.collect} />
        <Section number="2" title="How We Use Your Information" content={data.use} />
        <Section number="3" title="Third-Party Services" content={data.thirdParty} />
        <Section number="4" title="Advertising" content={data.advertising} />
        <Section
          number="5"
          title="Data Storage & Security"
          content={
            data.security ||
            'We take reasonable measures to protect your data. No method of transmission or storage is completely secure, and we cannot guarantee absolute security.'
          }
        />
        <Section number="6" title="Data Deletion" content={data.deletion} />
        <Section
          number="7"
          title="Children's Privacy"
          content={
            data.children ||
            `${name} is not directed to children under 13, and we do not knowingly collect data from them. If you believe a child has provided us with personal data, contact us and we will delete it promptly.`
          }
        />
        <Section
          number="8"
          title="Changes to This Policy"
          content={
            data.changes ||
            'We may update this policy from time to time. Changes will be posted on this page with an updated date.'
          }
        />

        <section className="pp-section">
          <h2 className="pp-h2">9. Contact Us</h2>
          <div className="pp-text">
            If you have any questions or concerns about this Privacy Policy, contact us at{' '}
            <a className="pp-link" href={`mailto:${email}`}>{email}</a>.
          </div>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
